const APIs = {
  LOGIN: `/api/Auth/LoginBackOffice`,
  AUTO_LOGIN: `/api/Auth/AutoLogin`,
  GET_USER_PROFILE: `/api/Company/Profile`,
  GET_USER_SETTINGS: `/api/Setting/GetUserSettings`,

  //Company
  GET_COMPANY: `/api/Company/UpdatedCompanyData`,
  GET_COMPANY_PROFILE: `/api/Company/Profile`,
  GET_COMPANY_BOOTSTRAP_PROFILE: `/api/Company/BootstrapProfile`,
  PUT_UPDATE_COMPANY_DATA: `/api/Company/UpdateCompany`,
  POST_REQUEST_COMPANY_EMAIL_CHANGE: `/api/Company/RequestCompanyEmailChange`,
  POST_CONFIRM_COMPANY_EMAIL_CHANGE: `/api/Company/ConfirmCompanyEmailChange`,
  POST_UPDATE_WEEKLY_SERVICE_HOURS: `/api/Company/UpdateCompanyServiceHours`,
  POST_UPDATE_COMPANY_LOGO: `/api/Company/UpdateCompanyLogo`,
  POST_UPDATE_COMPANY_COVER_IMAGE: `/api/Company/UpdateCompanyCoverImage`,
  GET_COMPANY_SETTINGS: `/api/Setting/GetCompanySettings`,
  BO_GET_COLLECTION_QR_LINK: `/api/Setting/BO_GetCollectionQrLink`,
  UPDATE_COMPANY_SETTINGS: `/api/Setting/UpdateCompanySettings`,
  POST_UPDATE_COMPANY_SETTING: `/api/Setting/UpdateCompanySettings`,
  POST_UPDATE_COMPANY_CONTACT_SETTINGS: `/api/Setting/UpdateCompanyContactSettings`,
  POST_UPDATE_SERVICE_HOURS: `/api/Setting/UpdateServiceHours`,
  REMOVE_COMPANY_LOGO: `/api/Company/RemoveCompanyLogo`,
  REMOVE_COMPANY_COVER_IMAGE: `/api/Company/RemoveCompanyCoverImage`,

  // Company media library (per-tenant images)
  GET_COMPANY_MEDIA_LIST: `/api/CompanyMedia/BO_GetCompanyMediaList`,
  GET_COMPANY_MEDIA_FILE: (mediaId) =>
    `/api/CompanyMedia/BO_GetCompanyMediaFile/${mediaId}`,
  POST_COMPANY_MEDIA_UPLOAD: `/api/CompanyMedia/BO_UploadCompanyMedia`,
  PATCH_COMPANY_MEDIA_ALT: `/api/CompanyMedia/BO_UpdateCompanyMediaAlt`,
  DELETE_COMPANY_MEDIA: (mediaId) =>
    `/api/CompanyMedia/BO_DeleteCompanyMedia/${mediaId}`,

  // CDS Banners (Settings / Administration; POS sync: GET with CompID + UDate)
  GET_PROMOTION_BANNERS: `/api/PromotionBanner/BO_GetPromotionBanners`,
  POST_PROMOTION_BANNERS_UPLOAD: `/api/PromotionBanner/BO_UploadPromotionBanners`,
  PATCH_PROMOTION_BANNER: `/api/PromotionBanner/BO_UpdatePromotionBanner`,
  DELETE_PROMOTION_BANNER: (id) =>
    `/api/PromotionBanner/BO_DeletePromotionBanner/${id}`,
  /** POS incremental sync — table tbl_PromotionBanners; merge Added/Updated, drop Deleted by id; image URL = API base + RelativePath */
  SYNC_PROMOTION_BANNERS: `/api/PromotionBanner/SyncUpdatedPromotionBanners`,

  // Online Ordering Banners (web carousel; separate from CDS)
  GET_ONLINE_ORDERING_BANNERS: `/api/OnlineOrderingBanner/BO_GetOnlineOrderingBanners`,
  POST_ONLINE_ORDERING_BANNERS_UPLOAD: `/api/OnlineOrderingBanner/BO_UploadOnlineOrderingBanners`,
  PATCH_ONLINE_ORDERING_BANNER: `/api/OnlineOrderingBanner/BO_UpdateOnlineOrderingBanner`,
  DELETE_ONLINE_ORDERING_BANNER: (id) =>
    `/api/OnlineOrderingBanner/BO_DeleteOnlineOrderingBanner/${id}`,

  // Catering services (Catering → Services)
  GET_CATERING_SERVICES: `/api/CateringService/BO_GetCateringServices`,
  POST_CATERING_SERVICE: `/api/CateringService/BO_AddOrUpdateCateringService`,
  DELETE_CATERING_SERVICE: (id) =>
    `/api/CateringService/BO_DeleteCateringService/${id}`,

  // Devices

  GET_ALL_DEVICES_OF_COMPANY: `/api/Device/BO_GetCompanyDevices`,
  GET_ALL_DEVICES: `/api/Device/GetCompanyDevices`,
  PATCH_UPDATE_DEVICE_STATUS: `/api/Device/UpdateCompanyStatus`,
  DELETE_COMPANY_DEVICE: `/api/Device/DeleteCompanyDevice`,

  // Payment Gateways

  GET_ALL_PAYMENT_GATEWAYS: `/api/PaymentGateway/BO_GetPaymentGateways`,
  POST_ADD_PAYMENT_GATEWAY: `/api/PaymentGateway/AddPaymentGateway`,
  UPDATE_PAYMENT_GATEWAY: `/api/PaymentGateway/UpdatePaymentGateway`,
  DELETE_PAYMENT_GATEWAY: `/api/PaymentGateway/DeletePaymentGateway`,
  GET_ACTIVE_PAYMENT_GATEWAY_PLATFORMS: `/api/PaymentGatewayPlatform/GetActivePlatforms`,

  // Twilio Gateway
  GET_TWILIO_GATEWAY: `/api/TwilioGateway/BO_GetTwilioGateway`,
  POST_ADD_TWILIO_GATEWAY: `/api/TwilioGateway/AddTwilioGateway`,
  UPDATE_TWILIO_GATEWAY: `/api/TwilioGateway/UpdateTwilioGateway`,
  DELETE_TWILIO_GATEWAY: `/api/TwilioGateway/DeleteTwilioGateway`,
  GET_TWILIO_PLATFORM_STATUS: `/api/TwilioPlatformConfig/BO_GetTwilioPlatformStatus`,

  // Company email sender (AWS SES)
  GET_COMPANY_EMAIL_SETTINGS: `/api/CompanyEmailSettings/BO_GetCompanyEmailSettings`,
  POST_ADD_UPDATE_COMPANY_EMAIL_SETTINGS: `/api/CompanyEmailSettings/BO_AddOrUpdateCompanyEmailSettings`,
  POST_COMPANY_EMAIL_SEND_TEST: `/api/CompanyEmailSettings/BO_SendTestEmail`,
  POST_SEND_EMAIL: `/api/Email/Send`,
  POST_SEND_SMS: `/api/Sms/Send`,

  // Customer SMS / WhatsApp conversations (POS + BackOffice)
  BO_SEND_MESSAGE: `/api/Messaging/BO_SendMessage`,
  POS_SEND_MESSAGE: `/api/Messaging/POS_SendMessage`,
  BO_GET_MESSAGING_QUOTA: `/api/Messaging/BO_GetMessagingQuota`,
  BO_GET_MESSAGING_USAGE_HISTORY: `/api/Messaging/BO_GetMessagingUsageHistory`,
  BO_GET_CUSTOMER_SMS_CONVERSATIONS: `/api/Messaging/BO_GetCustomerSmsConversations`,
  POS_GET_CUSTOMER_SMS_CONVERSATIONS: `/api/Messaging/POS_GetCustomerSmsConversations`,
  BO_GET_CUSTOMER_SMS_MESSAGES: `/api/Messaging/BO_GetCustomerSmsMessages`,
  POS_GET_CUSTOMER_SMS_MESSAGES: `/api/Messaging/POS_GetCustomerSmsMessages`,
  BO_GET_CUSTOMER_CONVERSATION_WITH_MESSAGES: `/api/Messaging/BO_GetCustomerConversationWithMessages`,
  POS_GET_CUSTOMER_CONVERSATION_WITH_MESSAGES: `/api/Messaging/POS_GetCustomerConversationWithMessages`,
  BO_MARK_CUSTOMER_SMS_CONVERSATION_READ: `/api/Messaging/BO_MarkCustomerSmsConversationRead`,
  POS_MARK_CUSTOMER_SMS_CONVERSATION_READ: `/api/Messaging/POS_MarkCustomerSmsConversationRead`,
  SYNC_CUSTOMER_SMS_CONVERSATIONS: `/api/Messaging/SyncUpdatedCustomerSmsConversations`,
  SYNC_CUSTOMER_SMS_MESSAGES: `/api/Messaging/SyncUpdatedCustomerSmsMessages`,

  //Petty Cash
  GET_PETTY_CASH_HEADS: `/api/PettyCash/BO_GetCashHeads`,
  POST_PETTY_CASH_HEAD: `/api/PettyCash/AddUpdatePettyCash`,
  PUT_UPDATE_PETTY_CASH_HEAD: `/api/PettyCash/AddUpdatePettyCash`,
  GET_PETTY_CASH_HEAD_BY_ID: `/api/PettyCash/GetCashHeadByID`,
  DELETE_PETTY_CASH_HEAD: `/api/PettyCash/DeletePettyCashByID`,
  UPDATE_PETTY_CASH_STATUS: `/api/PettyCash/UpdatePettyCashStatus`,

  // Staff
  GET_COMPANY_STAFF: `api/Staff/BO_GetCompanyStaff`,
  GET_ALL_STAFF: `/api/Staff/GetCompanyStaffList`,
  DELETE_COMPANY_STAFF: `api/Staff/DeleteStaff`,
  GET_STAFF_DATA: `/api/Staff/GetUserByUserName`,
  ADD_STAFF: `/api/Staff/AddUser`,
  UPDATE_STAFF: `/api/Staff/UpdateUser`,
  UPDATE_PASSWORD: `/api/Staff/UpdatePassword`,
  UPDATE_STAFF_IMAGE: `/api/Staff/UpdateStaffImage`,
  REMOVE_STAFF_IMAGE: `/api/Staff/RemoveStaffImage`,

  // Staff Time Tracking
  AUTO_CLOCK_OUT_EXPIRED_SHIFTS: `/api/StaffTimeTracking/AutoClockOutExpiredShifts`,

  // Staff Roster
  GET_STAFF_ROSTER_WEEK: `/api/StaffRoster/GetStaffRosterWeek`,
  GET_COMPANY_ROSTER_WEEK: `/api/StaffRoster/GetCompanyRosterWeek`,
  UPSERT_STAFF_ROSTER_WEEK: `/api/StaffRoster/UpsertStaffRosterWeek`,
  COPY_TEMPLATE_TO_ROSTER_WEEK: `/api/StaffRoster/CopyTemplateToRosterWeek`,
  GET_STAFF_ROSTER_LEAVE_DAYS: `/api/StaffRoster/GetStaffRosterLeaveDays`,
  SET_STAFF_ROSTER_AUTO_COPY: `/api/StaffRoster/SetStaffRosterAutoCopy`,


  // Staff Work Report
  GET_STAFF_WORK_REPORT: `/api/StaffReport/GetStaffShiftReport`,
  GET_ALL_STAFF_WORK_REPORTS: `/api/StaffReport/GetAllStaffShiftReports`,
  GET_STAFF_SALES_REPORT: `/api/StaffReport/GetStaffWorkReport`,

  // Staff Payout
  GENERATE_PAYOUT: `/api/StaffPayout/GeneratePayout`,
  GET_PAYOUTS: `/api/StaffPayout/GetPayouts`,
  GET_UNPAID_HOURS: `/api/StaffPayout/GetUnpaidHours`,
  APPROVE_PAYOUT: `/api/StaffPayout/ApprovePayout`,
  PROCESS_PAYOUT: `/api/StaffPayout/ProcessPayout`,
  GET_PAYOUT_DETAILS: `/api/StaffPayout/GetPayoutDetails`,


  // Suppliers
  GET_ALL_SUPPLIERS: `/api/Supplier/BO_GetSupplierList`,
  GET_SUPPLIER_BY_ID: `/api/Supplier/GetSupplierByID`,
  POST_ADD_SUPPLIER: `/api/Supplier/AddSupplier`,
  PUT_UPDATE_SUPPLIER: `/api/Supplier/UpdateSupplier`,
  DELETE_SUPPLIER_BY_ID: `/api/Supplier/DeleteSupplierByID`,

  //Roles
  GET_ROLES: `/api/RolePermission/GetAllRoles`,
  GET_ROLE_BY_ID: `/api/RolePermission/GetRoleByID`,
  ADD_ROLE: `/api/RolePermission/AddNewRole`,
  UPDATE_ROLE: `/api/RolePermission/UpdateRolePermission`,
  DELETE_ROLE: `/api/RolePermission/DeleteRole`,

  // Countries
  GET_COUNTRIES: `/api/Country/GetAllCountries`,

  //City

  GET_ALL_CITIES: `/api/City/GetAllCitiesListForCountryCode`,

  // Categories
  GET_CATEGORIES: `/api/RootCategories/BO_GetAllCategories`,
  GET_CATEGORY_ROOT_ID: `/api/RootCategories/GetRootCategoryByRootCatID`,
  ADD_CATEGORY: `/api/RootCategories/AddCategory`,
  UPDATE_CATEGORY: `/api/RootCategories/UpdateCategory`,
  POST_UPDATE_CATEGORY_SORT_ORDER: `/api/RootCategories/UpdateCategorySortOrder`,
  POST_UPDATE_ROOT_CATEGORY_ITEM_SORT_ORDER: `/api/RootCategoryItems/UpdateRootCategoryItemSortOrder`,
  POST_UPDATE_CATEGORY_STATUS: `/api/RootCategories/UpdateCategoryStatus`,
  DELETE_ROOT_CATEGORY: `/api/RootCategories/DeleteCategory`,

  //Category Departments
  GET_ALL_CATEGORY_DEPARTMENTS: `/api/CategoryDepartments/BO_GetCompanyCategoryDepartments`,
  GET_CATEGORY_DEPARTMENT_BY_ID: `/api/CategoryDepartments/GetCategoryDepartmentByID`,
  POST_ADD_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/InsertCategoryDepartment`,
  PUT_UPDATE_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/UpdateCategoryDepartment`,
  DELETE_CATEGORY_DEPARTMENT: `/api/CategoryDepartments/DeleteCategoryDepartment`,
  POST_UPDATE_CATEGORY_DEPARTMENT_SORT_ORDER: `/api/CategoryDepartments/UpdateCategoryDepartmentSortOrder`,
  GET_ALL_CATEGORY_DEPARTMENT_RELATIONS: `/api/CatDepartmentRelation/GetAllCategoryDepartmentRelations`,

  // Category Types
  GET_ALL_CATEGORY_TYPES: `/api/CategoryType/GetAllCategoryTypes`,
  GET_CATEGORY_TYPE_BY_ID: `/api/CategoryType/GetCategoryTypeByID`,
  POST_ADD_CATEGORY_TYPE: `/api/CategoryType/InsertCategoryType`,
  PUT_UPDATE_CATEGORY_TYPE: `/api/CategoryType/UpdateCategoryType`,
  DELETE_CATEGORY_TYPE: `/api/CategoryType/DeleteCategoryType`,
  POST_UPDATE_CATEGORY_TYPE_SORT_ORDER: `/api/CategoryType/UpdateCategoryTypeSortOrder`,


  // Menus

  POST_ADD_MENU: `/api/Menu/AddMenu`,
  POST_ADD_MENU_GROUP_LIST: `/api/MenuGroup/AddMenuGroupList`,
  GET_MENU_LIST: `/api/Menu/BO_GetAllMenus`,
  GET_MENU_BY_MENU_ID: `/api/Menu/GetMenuByMenuID`,
  GET_All_MENU_GroupS: `/api/Menu/GetAllMenusWithTheirGroups`,
  DELETE_MENU: `/api/Menu/DeleteMenu`,
  PUT_UPDATE_MENU_AND_MENU_GROUP: `/api/Menu/UpdateMenu`,
  POST_UPDATE_MENU_SORT_ORDER: `/api/Menu/UpdateMenuSortOrder`,
  POST_UPDATE_MENU_STATUS: `/api/Menu/UpdateMenuStatus`,

  //  Item
  POST_CREATE_MENU_ITEM: `/api/Item/AddMenuItem`,
  GET_ALL_ITEMS_FOR_GRID: `/api/Item/BO_GetAllItems`,
  GET_ALL_PRODUCTS: `/api/Item/GetAllMenuItems`,
  GET_ALL_ONLY_PRODUCTS: `/api/Item/GetAllOnlyMenuItems`,
  POST_UPLOAD_PRODUCT_IMAGE: `/api/Item/UploadMenuItemImage`,
  GET_ITEM_BY_ID: `/api/Item/GetMenuItemByID`,
  PUT_UPDATE_ITEM: `/api/Item/UpdateMenuItem`,
  DELETE_ITEM: `/api/Item/DeleteMenuItem`,
  POST_UPDATE_ITEM_SORT_ORDER: `/api/Item/UpdateMenuItemSortOrder`,
  POST_UPDATE_ITEM_STATUS: `/api/Item/UpdateMenuItemStatus`,
  GET_ALL_SHORTED_PRODUCTS: `/api/Item/GetMenuItemsWithShortDetail`,
  PUT_BULK_UPDATE_ITEMS : `/api/Item/BulkUpdateMenuItems`,
  POST_BULK_GET_ITEMS : `/api/Item/BulkGetMenuItemsByIds`,

  // Special Items
  GET_SPECIAL_ITEMS: `/api/SpecialItem/BO_GetSpecialItems`,
  GET_SPECIAL_MENU_ITEMS: `/api/SpecialItem/BO_GetSpecialMenuItems`,
  ADD_SPECIAL_ITEM: `/api/SpecialItem/AddSpecialItem`,
  UPDATE_SPECIAL_ITEM: `/api/SpecialItem/UpdateSpecialItem`,
  DELETE_SPECIAL_ITEM: `/api/SpecialItem/DeleteSpecialItem`,
  MAKE_MENU_ITEM_SPECIAL: `/api/SpecialItem/MakeMenuItemSpecial`,
  REMOVE_MENU_ITEM_FROM_SPECIAL: `/api/SpecialItem/RemoveMenuItemFromSpecial`,

  // Menu Presets
  GET_MENU_PRESETS: `/api/MenuPreset/BO_GetMenuPresets`,
  ADD_MENU_PRESET: `/api/MenuPreset/AddMenuPreset`,
  UPDATE_MENU_PRESET: `/api/MenuPreset/UpdateMenuPreset`,
  DELETE_MENU_PRESET: `/api/MenuPreset/DeleteMenuPreset`,

  // Modifiers
  GET_ALL_MODIFIERS: `/api/Modifier/BO_GetAllModifiers`,
  GET_SEARCH_MODIFIERS: `/api/Modifier/BO_SearchModifier`,

  // Modifier Group

  POST_ADD_MODIFIER_GROUP: `/api/ModifierGroup/AddModifierGroup`,
  GET_ALL_MODIFIER_GROUPS: `/api/ModifierGroup/BO_GetAllModifierGroups`,
  DELETE_MODIFIER_GROUP: `/api/ModifierGroup/DeleteModifierGroup`,
  POST_CHANGE_SKIP_ABLE: `/api/ModifierGroup/ChangeModifierSKipAble`,
  GET_MODIFIER_GROUP_BY_ID: `/api/ModifierGroup/GetModifierGroupByID`,
  PUT_UPDATE_MODIFIER_GROUP: `/api/ModifierGroup/UpdateModifierGroup`,
  POST_ASSIGN_ITEMS_TO_MODIFIER_GROUP: `/api/ItemModifierGroups/AssignItemsToModifierGroup`,
  POST_BULK_ASSIGN_ITEMS_TO_MODIFIER_GROUPS: `/api/ItemModifierGroups/BulkAssignItemsToModifierGroups`,

  //Discount
  GET_ALL_DISCOUNTS: `/api/Discount/BO_GetCompanyDiscountEntry`,
  GET_DISCOUNT_BY_ID: `/api/Discount/GetDiscountByID`,
  POST_ADD_DISCOUNT: `/api/Discount/InsertDiscountEntry`,
  PUT_UPDATE_DISCOUNT: `/api/Discount/UpdateDiscountEntry`,
  DELETE_DISCOUNT: `/api/Discount/DeleteDiscountEntry`,

  //Orders
  GET_ALL_ORDERS: `/api/RecvOrder/BO_GetOrders`,
  DELETE_ORDER: `/api/RecvOrder/DeleteRecvOrder`,
  ARCHIEVE_ORDER: `/api/RecvOrder/ArchieveRecvOrder`,
  GET_ORDER_BY_INVOICE_NO: `/api/RecvOrder/GetOrderByInvoiceNo`,
  UPDATE_RECV_ORDER: `/api/RecvOrder/UpdateRecvOrder`,
  POST_SEND_ORDER_DETAILS_EMAIL_TO_CUSTOMER: `/api/RecvOrder/SendOrderDetailsEmailToCustomer`,

  //Service Time
  GET_ALL_SERVICE_TIME: `/api/ServiceTime/GetAllServiceTimes`,
  GET_SERVICE_TIME_BY_ID: `/api/ServiceTime/GetServiceTimeforID`,
  POST_ADD_SERVICE_TIME: `/api/ServiceTime/AddServiceTime`,
  PUT_UPDATE_SERVICE_TIME: `/api/ServiceTime/UpdateServiceTime`,
  DELETE_SERVICE_TIME: `/api/ServiceTime/DeleteServiceTime`,

  //Service Time Details
  GET_SERVICE_TIME_DETAILS: `/api/ServiceTimeDetail/GetServiceTimeDetailList`,
  GET_SERVICE_TIME_DETAIL_BY_ID: `/api/ServiceTimeDetail/GetAllServiceTimeDetailsByCompany`,
  POST_ADD_SERVICE_TIME_DETAIL: `/api/ServiceTimeDetail/AddServiceTimeDetail`,

  // Customers
  GET_ALL_CUSTOMERS: `/api/Customer/BO_GetCustomerList`,
  GET_ALL_CUSTOMERS_GROUP_TYPE_LIST: `/api/CustomerTypeGroup/GetAllCustomerTypeGroups`,
  GET_CUSTOMERS_GROUP: `/api/CustomerTypeGroup/BO_GetCustomerTypeGroupList`,
  POST_ADD_UPDATE_CUSTOMER_GROUP: `/api/CustomerTypeGroup/AddUpdateCustomerGroup`,
  DELETE_CUSTOMER_GROUP_TYPE: `/api/CustomerTypeGroup/DeleteCustomerGroup`,
  POST_ADD_UPDATE_CUSTOMER: `/api/Customer/AddUpdateCustomer`,
  GET_CUSTOMER_BY_ID: `/api/Customer/GetCustomerByID`,
  GET_CUSTOMER_BY_CUST_GUID: `/api/Customer/GetCustomerByCustGuid`,
  // PUT_UPDATE_CUSTOMER: `/api/Customer/UpdateCustomer`,
  PATCH_UPDATE_CUSTOMER_EMAIL_ADDRESS: `/api/Customer/UpdateCustomerEmailAddress`,
  DELETE_CUSTOMER_BY_ID: `/api/Customer/DeleteCustomerByID`,

  // Marketing Groups
  GET_MARKETING_GROUPS: `/api/MarketingGroup/BO_GetMarketingGroups`,
  GET_MARKETING_GROUP_BY_ID: (id) => `/api/MarketingGroup/BO_GetMarketingGroupById/${id}`,
  POST_ADD_UPDATE_MARKETING_GROUP: `/api/MarketingGroup/BO_AddOrUpdateMarketingGroup`,
  DELETE_MARKETING_GROUP: (guid) => `/api/MarketingGroup/BO_DeleteMarketingGroup/${guid}`,
  GET_CUSTOMERS_FOR_MARKETING_GROUP_PICKER: `/api/MarketingGroup/BO_GetCustomersForGroupPicker`,
  GET_MARKETING_GROUP_CUSTOMERS: (id) => `/api/MarketingGroup/BO_GetMarketingGroupCustomers/${id}`,

  // SMS Presets
  GET_SMS_PRESETS: `/api/SmsPreset/BO_GetSmsPresets`,
  GET_SMS_PRESET_BY_ID: (id) => `/api/SmsPreset/BO_GetSmsPresetById/${id}`,
  POST_ADD_UPDATE_SMS_PRESET: `/api/SmsPreset/BO_AddOrUpdateSmsPreset`,
  DELETE_SMS_PRESET: (guid) => `/api/SmsPreset/BO_DeleteSmsPreset/${guid}`,
  GET_SMS_PRESET_PLACEHOLDERS: `/api/SmsPreset/BO_GetSmsPresetPlaceholders`,
  POST_PREVIEW_SMS_PRESET_MESSAGE: `/api/SmsPreset/BO_PreviewSmsPresetMessage`,
  SYNC_UPDATED_SMS_PRESETS: `/api/SmsPreset/SyncUpdatedSmsPresets`,

  // Email Presets
  GET_EMAIL_PRESETS: `/api/EmailPreset/BO_GetEmailPresets`,
  GET_EMAIL_PRESET_BY_ID: (id) => `/api/EmailPreset/BO_GetEmailPresetById/${id}`,
  POST_ADD_UPDATE_EMAIL_PRESET: `/api/EmailPreset/BO_AddOrUpdateEmailPreset`,
  DELETE_EMAIL_PRESET: (guid) => `/api/EmailPreset/BO_DeleteEmailPreset/${guid}`,
  GET_EMAIL_PRESET_PLACEHOLDERS: `/api/EmailPreset/BO_GetEmailPresetPlaceholders`,
  POST_PREVIEW_EMAIL_PRESET: `/api/EmailPreset/BO_PreviewEmailPreset`,
  SYNC_UPDATED_EMAIL_PRESETS: `/api/EmailPreset/SyncUpdatedEmailPresets`,

  GET_MARKETING_SETTINGS: `/api/MarketingSettings/BO_GetMarketingSettings`,
  POST_ADD_UPDATE_MARKETING_SETTINGS: `/api/MarketingSettings/BO_AddOrUpdateMarketingSettings`,

  // Campaigns
  GET_CAMPAIGNS: `/api/Campaign/BO_GetCampaigns`,
  GET_CAMPAIGN_BY_GUID: (guid) => `/api/Campaign/BO_GetCampaignByGuid/${guid}`,
  POST_ADD_UPDATE_CAMPAIGN: `/api/Campaign/BO_AddOrUpdateCampaign`,
  DELETE_CAMPAIGN: (guid) => `/api/Campaign/BO_DeleteCampaign/${guid}`,
  POST_PREVIEW_CAMPAIGN: `/api/Campaign/BO_PreviewCampaign`,
  POST_RUN_CAMPAIGN: `/api/Campaign/BO_RunCampaign`,
  GET_CAMPAIGN_RUN_STATUS: (runGuid) => `/api/Campaign/BO_GetCampaignRunStatus/${runGuid}`,
  GET_CAMPAIGN_RUNS: `/api/Campaign/BO_GetCampaignRuns`,
  GET_CAMPAIGN_RUN_RECIPIENTS: `/api/Campaign/BO_GetCampaignRunRecipients`,

  // Receipt Info
  GET_RECEIPT_INFO: `/api/Receipt/GetReceiptInfo`,
  POST_UPDATE_RECEIPT_INFO: `/api/Receipt/UpdateReceiptInfo`,

  // Currency
  GET_ALL_CURRENCIES: `/api/Shared/GetAllCurrencies`,
  GET_ALL_TIMEZONE: `/api/Shared/GetAllTimeZones`,

  // Voucher
  GET_ALL_VOUCHERS: `/api/Voucher/BO_GetCompanyVouchers`,
  GET_VOUCHER_BY_ID: `/api/Voucher/GetVoucherByID`,
  POST_ADD_VOUCHER: `/api/Voucher/InsertVoucher`,
  PUT_UPDATE_VOUCHER: `/api/Voucher/UpdateVoucher`,
  DELETE_VOUCHER: `/api/Voucher/DeleteVoucher`,

  // Deals
  GET_ALL_DEALS: `/api/Deal/GetAllDeals`,
  GET_ALL_DEALS_FOR_GRID: `/api/Deal/BO_GetAllDeals`,
  GET_DEAL_BY_ID: `/api/Deal/GetDealByID`,
  GET_ACTIVE_PUBLISHED_DEALS: `/api/Deal/GetActivePublishedDeals`,
  POST_ADD_OR_UPDATE_DEAL: `/api/Deal/AddOrUpdateDeal`,
  DELETE_DEAL: `/api/Deal/DeleteDeal`,

  // Deal Slots
  GET_DEAL_SLOTS_BY_DEAL_ID: `/api/DealSlot/GetDealSlotsByDealID`,
  GET_DEAL_SLOT_BY_ID: `/api/DealSlot/GetDealSlotByID`,
  POST_ADD_OR_UPDATE_DEAL_SLOT: `/api/DealSlot/AddOrUpdateDealSlot`,
  DELETE_DEAL_SLOT: `/api/DealSlot/DeleteDealSlot`,

  // Deal Slot Allowed Categories
  GET_DEAL_SLOT_ALLOWED_CATEGORIES: `/api/DealSlotAllowedCategory/GetDealSlotAllowedCategories`,
  POST_ADD_DEAL_SLOT_ALLOWED_CATEGORY: `/api/DealSlotAllowedCategory/AddDealSlotAllowedCategory`,
  DELETE_DEAL_SLOT_ALLOWED_CATEGORY: `/api/DealSlotAllowedCategory/DeleteDealSlotAllowedCategory`,
  DELETE_DEAL_SLOT_ALLOWED_CATEGORIES_BY_SLOT_ID: `/api/DealSlotAllowedCategory/DeleteDealSlotAllowedCategoriesBySlotID`,

  // Deal Slot Allowed Items
  GET_DEAL_SLOT_ALLOWED_ITEMS: `/api/DealSlotAllowedItem/GetDealSlotAllowedItems`,
  POST_ADD_DEAL_SLOT_ALLOWED_ITEM: `/api/DealSlotAllowedItem/AddDealSlotAllowedItem`,
  DELETE_DEAL_SLOT_ALLOWED_ITEM: `/api/DealSlotAllowedItem/DeleteDealSlotAllowedItem`,
  DELETE_DEAL_SLOT_ALLOWED_ITEMS_BY_SLOT_ID: `/api/DealSlotAllowedItem/DeleteDealSlotAllowedItemsBySlotID`,

  // Deal Slot Constraints
  GET_DEAL_SLOT_CONSTRAINT: `/api/DealSlotConstraint/GetDealSlotConstraint`,
  POST_ADD_OR_UPDATE_DEAL_SLOT_CONSTRAINT: `/api/DealSlotConstraint/AddOrUpdateDealSlotConstraint`,
  DELETE_DEAL_SLOT_CONSTRAINT: `/api/DealSlotConstraint/DeleteDealSlotConstraint`,

  // Deal Weekly Timings
  GET_DEAL_WEEKLY_TIMINGS: `/api/DealWeeklyTiming/GetDealWeeklyTimings`,
  POST_ADD_DEAL_WEEKLY_TIMING: `/api/DealWeeklyTiming/AddDealWeeklyTiming`,
  DELETE_DEAL_WEEKLY_TIMING: `/api/DealWeeklyTiming/DeleteDealWeeklyTiming`,

  // Reports
  GET_TODAY_SALE: `/api/SalesReport/GetTodaySale`,
  GET_HOURLY_SALES_FOR_CHART: `/api/SalesReport/GetHourlySalesForChart`,
  GET_TENDER_SALES_FOR_CHART: `/api/SalesReport/GetTenderSalesForChart`,
  GET_SALES_BREAKDOWN_BY_TIME: `/api/SalesReport/GetSalesBreakdownByTime`,
  GET_SALES_BREAKDOWN_SUMMARY: `/api/SalesReport/GetSalesBreakdownSummary`,
  GET_SALES_BREAKDOWN_BY_PRODUCT: `/api/SalesReport/GetSalesBreakdownByProduct`,
  GET_SALES_BREAKDOWN_BY_PRODUCT_SUMMARY: `/api/SalesReport/GetSalesBreakdownByProductSummary`,
  GET_DEAL_PERFORMANCE_REPORT: `/api/SalesReport/GetDealPerformanceReport`,
  GET_DEAL_PERFORMANCE_SUMMARY: `/api/SalesReport/GetDealPerformanceSummary`,
  GET_DASHBOARD_TOP_5_PRODUCTS: `/api/SalesReport/GetTop5ProductsForDashboard`,
  GET_COMPANY_LOCATIONS: `/api/Company/GetCompanyLocations`,
  GET_TABLE_SPENT_REPORT: `/api/TableReport/GetTableSpent`,
  GET_COVERS_SPENT_REPORT: `/api/TableReport/GetCoversSpent`,
  GET_RESERVATION_STATS_SUMMARY: `/api/TableReport/GetReservationStatsSummary`,
  GET_SERVICE_AREAS: `/api/ServiceArea/GetAllServiceAreas`,

  // Z-Report
  GET_Z_REPORT_PREVIEW: `/api/ZReport/GetZReportPreview`,
  RUN_Z_REPORT: `/api/ZReport/RunZReport`,
  GET_Z_REPORT_HISTORY_PAGINATED: `/api/ZReport/GetZReportHistoryPaginated`,
  GENERATE_Z_REPORT_PDF: `/api/ZReport/GenerateZReportPDF`,

  // Cash Report
  GET_PETTY_CASH_REPORT: `/api/CashReport/GetPettyCashReport`,
  GET_FLOAT_CASH_REPORT: `/api/CashReport/GetFloatCashReport`,
  GET_CASH_REPORT_WITH_FILTERS: `/api/CashReport/GetCashReportWithFilters`,

  // Advance Deposit Rules
  GET_ADVANCE_DEPOSIT_RULES: `/api/ReservationAdvanceDepositRule/BO_GetAdvanceDepositRules`,
  GET_ADVANCE_DEPOSIT_RULE_BY_ID: `/api/ReservationAdvanceDepositRule/GetAdvanceDepositRuleByID`,
  POST_ADD_UPDATE_ADVANCE_DEPOSIT_RULE: `/api/ReservationAdvanceDepositRule/AddUpdateAdvanceDepositRule`,
  POST_UPDATE_ADVANCE_DEPOSIT_RULE_STATUS: `/api/ReservationAdvanceDepositRule/UpdateAdvanceDepositRuleStatus`,
  DELETE_ADVANCE_DEPOSIT_RULE: `/api/ReservationAdvanceDepositRule/DeleteAdvanceDepositRule`,

  // Service Area Image Upload
  UPLOAD_SERVICE_AREA_IMAGE: `/api/ServiceArea/UploadServiceAreaImage`,

  GET_SERVICE_AREA_BY_ID: `/api/ServiceArea/GetServiceAreaByID`,

  // Table QR (Online Ordering dine-in deep links)
  BO_GET_TABLE_QR_LINK: `/api/ServiceAreaTable/BO_GetTableQrLink`,
  BO_GET_SERVICE_AREA_TABLE_QR_LINKS: `/api/ServiceAreaTable/BO_GetServiceAreaTableQrLinks`,

  // Global Search
  GLOBAL_SEARCH: `/api/Search/GlobalSearch`,

  // Delivery Charge Rules (postcode-based)
  GET_DELIVERY_CHARGE_RULES: `/api/DeliveryCharge/BO_GetRules`,
  ADD_DELIVERY_CHARGE_RULE: `/api/DeliveryCharge/AddRule`,
  UPDATE_DELIVERY_CHARGE_RULE: `/api/DeliveryCharge/UpdateRule`,
  DELETE_DELIVERY_CHARGE_RULE: `/api/DeliveryCharge/DeleteRule`,

  // Loyalty Program
  GET_LOYALTY_ANALYTICS: `/api/Loyalty/GetAnalytics`,
  CALCULATE_ORDER_POINTS: `/api/Loyalty/CalculateOrderPoints`,
  GET_CUSTOMER_LOYALTY_STATUS: `/api/Loyalty/GetCustomerStatus`,
  GET_CUSTOMER_ORDERS: `/api/RecvOrder/BO_GetCustomerOrders`,
  GET_LOYALTY_RULE: `/api/Loyalty/GetRule`,
  UPSERT_LOYALTY_RULE: `/api/Loyalty/UpsertRule`,
  UPSERT_LOYALTY_RULE_CONDITION: `/api/Loyalty/UpsertRuleCondition`,
  DELETE_LOYALTY_RULE_CONDITION: `/api/Loyalty/DeleteRuleCondition`,
  GET_AVAILABLE_REWARDS: `/api/Rewards/GetAvailableRewards`,
  GET_ALL_REWARDS: `/api/Rewards/GetAllRewards`,
  GET_REWARDS: `/api/Rewards/GetRewards`,
  GET_SINGLE_REWARD: `/api/Rewards/GetRewardByID`,
  UPSERT_REWARD: `/api/Rewards/UpsertReward`,
  UPSERT_REWARD_CONDITION: `/api/Rewards/UpsertRewardCondition`,
  DELETE_REWARD_CONDITION: `/api/Rewards/DeleteRewardCondition`,
  DELETE_REWARD: `/api/Rewards/DeleteReward`,
  UPDATE_REWARD_STATUS: `/api/Rewards/UpdateRewardStatus`,
  REDEEM_LOYALTY_REWARD: `/api/Rewards/RedeemReward`,
  VALIDATE_REWARD_REDEMPTION: `/api/Rewards/ValidateRedemption`,

  // Subscription invoices (platform SaaS billing)
  GET_COMPANY_INVOICES: `/api/Invoice/GetCompanyInvoices`,
  GET_INVOICE_BY_ID: `/api/Invoice/GetInvoiceByID`,
  POST_PREPARE_INVOICE_DOJO_CHECKOUT: `/api/Invoice/PrepareInvoiceDojoCheckout`,
  GET_INVOICE_DOJO_CHECKOUT_STATUS: `/api/Invoice/GetInvoiceDojoCheckoutStatus`,
  POST_FINALIZE_INVOICE_DOJO_CHECKOUT: `/api/Invoice/FinalizeInvoiceDojoCheckout`,

  // EPOS / Flutter subscription billing
  EPOS_GET_INVOICE_YEAR_SUMMARY: `/api/Invoice/EPOS_GetInvoiceYearSummary`,
  EPOS_GET_INVOICES_BY_MONTH: `/api/Invoice/EPOS_GetInvoicesByMonth`,
  EPOS_GET_COMPANY_INVOICES: `/api/Invoice/EPOS_GetCompanyInvoices`,
  EPOS_GET_INVOICE_DETAIL: `/api/Invoice/EPOS_GetInvoiceDetail`,
  EPOS_REQUEST_INVOICE_REFUND: `/api/Invoice/EPOS_RequestInvoiceRefund`,

  // EPOS SMS credits / top-up packs
  EPOS_GET_SMS_BALANCE: `/api/Invoice/EPOS_GetSmsBalance`,
  EPOS_GET_SMS_PACKAGES: `/api/SmsPackage/EPOS_GetSmsPackages`,
  EPOS_PURCHASE_SMS_PACKAGE: `/api/SmsPackage/EPOS_PurchaseSmsPackage`,

  // Dashboard bottom panels (SMS Details + upcoming reservations)
  BO_GET_DASHBOARD_SMS_SUMMARY: `/api/Invoice/BO_GetDashboardSmsSummary`,
  BO_GET_DASHBOARD_UPCOMING_RESERVATIONS: `/api/Reservation/BO_GetDashboardUpcomingReservations`,
};

export default APIs;
